<template>
  <div>
    <pills :filtro="filtro" class="mb-2" />
    <b-table small head-variant="dark" hover :items="dados" :fields="colunas">
      <template #cell(nomeFantasia)="data">
        <b-link @click="getLink(data.item)">{{
          data.item.nomeFantasia
        }}</b-link>
      </template>
      <template #cell(apelido)="data">
        <b-link @click="getLink(data.item)">{{ data.item.apelido }}</b-link>
      </template>
      <template #cell(codigoProjeto)="data">
        <b-link @click="getLink(data.item)">{{
          data.item.codigoProjeto
        }}</b-link>
      </template>
      <template #cell(status)="data">
        <div>
          <b-badge :variant="data.value.variante">{{
            data.value.text
          }}</b-badge>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import Pills from "./Pills";
import DashboardExecutoraService from "@/common/services/dashboards/dashboard_executora.service.js";
import helpers from "@/common/utils/helpers";
export default {
  components: {
    Pills,
  },
  data: () => ({
    filtro: {},
    dados: [],
    colunas: [
      {
        key: "apelido",
        label: "Apelido",
      },
      {
        key: "codigoProjeto",
        label: "Código do projeto",
      },
      {
        key: "dataInicio",
        label: "Data de inicio",
        formatter: (value) => {
          if (value) return helpers.formatarDataBr(value);
        },
      },
      {
        key: "dataFim",
        label: "Data de término",
        formatter: (value) => {
          if (value) return helpers.formatarDataBr(value);
        },
      },
      {
        key: "faseInovacao",
        label: "Fase de inovação",
        formatter: (value) => {
          if (value) return helpers.getEnum(value).text;
        },
      },
      {
        key: "status",
        label: "Status",
        formatter: (value) => {
          if (value) return helpers.getEnum(value);
        },
      },
    ],
  }),
  methods: {
    buscarDados: function (filtro = {}) {
      this.filtro = filtro;
      DashboardExecutoraService.projetos(
        this.empresasSelecionada,
        null,
        filtro
      ).then((response) => {
        this.dados = response.data.data;
      });
    },
    getLink(projeto) {
      if (projeto.ehGestao) {
        return this.$router.push({
          name: "projeto-gestao-proponente-detalhamento",
          params: { id: projeto.id },
        });
      }
      if (projeto.ehExecutoraCriadora) {
        return this.$router.push({
          name: "projeto-detalhamento-executora-criadora",
          params: { id: projeto.id },
        });
      } 
      return this.$router.push({
        name: "projeto-detalhamento-executora-associada",
        params: { id: projeto.id },
      });
    },
  },
  mounted() {
    this.buscarDados();
  },
  computed: {
    empresasSelecionada: function () {
      if (!this.$store.state.app.selectedCompanyObj) return null;
      return this.$store.state.app.selectedCompanyObj.id;
    },
  },
};
</script>
<style lang="">
</style>